import { ca } from '@cian/analytics';

interface ITrackBookingErrorParams {
  error?: string;
}

export const trackBookingError = ({ error }: ITrackBookingErrorParams) => {
  ca('eventSite', {
    action: 'error',
    category: 'booking',
    name: 'oldevent',
    label: 'confirmation_redirect',
    page: {
      pageType: 'Card',
      siteType: 'desktop',
      extra: { error },
    },
    useLastProducts: true,
  });
};
